import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { __decorate } from "tslib";
import { TweenLite } from 'gsap';
import { Options, Vue } from 'vue-class-component';
// base on https://www.npmjs.com/package/vue-number-animation
// Returns the number of full stop in given string.
var countFullstops = function countFullstops(str) {
  return str.replace(/[^.]/g, '').length;
};
var numberAnimation = /*#__PURE__*/function (_Vue) {
  function numberAnimation() {
    _classCallCheck(this, numberAnimation);
    return _callSuper(this, numberAnimation, arguments);
  }
  _inherits(numberAnimation, _Vue);
  return _createClass(numberAnimation);
}(Vue);
numberAnimation = __decorate([Options({
  props: {
    from: {
      type: [Number, String],
      default: 0
    },
    to: {
      type: [Number, String],
      required: true,
      default: 0
    },
    format: {
      type: Function,
      default: function _default(num) {
        return parseInt(num, 10);
      }
    },
    duration: {
      type: Number,
      default: 1 // Duration of animation in seconds
    },
    easing: {
      type: String,
      default: 'Power4.easeOut'
    },
    delay: {
      type: Number,
      default: 0 // Delay the animation in seconds
    },
    animationPaused: Boolean // Stops animation before start
  },
  data: function data() {
    return {
      fromProp: this.from
    };
  },
  computed: {
    tweenedNumber: function tweenedNumber() {
      return this.format(this.fromProp);
    }
  },
  methods: {
    tween: function tween(value) {
      var vm = this;
      var tLite = TweenLite.to(vm.$data, vm.duration, {
        fromProp: value,
        paused: vm.animationPaused,
        ease: vm.easeCheck(),
        onStart: function onStart() {
          return vm.$emit('start');
        },
        onComplete: function onComplete() {
          return vm.$emit('complete');
        },
        onUpdate: function onUpdate() {
          return vm.$emit('update');
        },
        delay: vm.delay // In seconds
      });
      vm.tween.tLite = tLite;
    },
    play: function play() {
      this.tween.tLite.play();
    },
    pause: function pause() {
      this.tween.tLite.pause();
    },
    restart: function restart() {
      this.tween.tLite.restart();
    },
    easeCheck: function easeCheck() {
      var vm = this;
      if (countFullstops(vm.easing) !== 1) {
        throw new Error('Invalid ease type. (eg. easing="Power1.easeOut")');
      }
      return vm.easing;
    }
  },
  watch: {
    to: function to(newValue) {
      this.tween(newValue);
    }
  },
  mounted: function mounted() {
    this.tween(this.to);
  }
})], numberAnimation);
export default numberAnimation;